<template lang="pug">
#select-laudo
    h2 {{ $t('laudos.selecioneTipoDeLaudo') }}
    el-select(
        v-model='laudoSelecionado',
        :placeholder='$t("mensagens.comuns.selecione")',
        @change='mudarLaudo',
        clearable,
        @clear='limparSelecao'
    )
        el-option(
            v-for='tipo in tipos',
            :key='tipo.id',
            :label='traduzirNomeLaudo(tipo.nome)',
            :value='tipo.id'
        )
</template>

<script>
import LaudoEmpresaService from '@/modules/laudos/services/LaudoEmpresaService';
import { mapGetters } from 'vuex';
import EventBus from '@/utils/eventBus';
import { orderBy } from 'lodash';
import tradutorDeLaudos from '@/modules/laudos/utils/tradutorDeLaudos';
import TipoLaudo from '@/modules/laudos/constants/TipoLaudo';

const routesLink = [
    { id: 99, nomeComponent: 'LaudosDashboard' },
    { id: TipoLaudo.AGRICOLA, nomeComponent: 'LaudosAgricola' },
    {
        id: TipoLaudo.BACEN_FISCALIZACAO,
        nomeComponent: 'LaudosBacenFiscalizacao'
    },
    { id: TipoLaudo.BENFEITORIAS, nomeComponent: 'LaudosBenfeitorias' },
    {
        id: TipoLaudo.CONFORMIDADE,
        nomeComponent: 'LaudosConformidadeAmbiental'
    },
    { id: TipoLaudo.CARBONO, nomeComponent: 'LaudoCarbono' },
    {
        id: TipoLaudo.HISTORICO_AGRICOLA,
        nomeComponent: 'LaudoHistoricoAgricola'
    },
    {
        id: TipoLaudo.DIAGNOSTICO_AGRICOLA,
        nomeComponent: 'LaudoDiagnosticoAgricola'
    },
    { id: TipoLaudo.SUPRESSAO_VEGETAL, nomeComponent: 'LaudoSupressaoVegetal' },
    { id: TipoLaudo.TECNICO_AGRICOLA, nomeComponent: 'LaudoTecnicoAgricola' },
    { id: TipoLaudo.CROQUI_LOCALIZACAO, nomeComponent: 'LaudoCroqui' },
    { id: TipoLaudo.BACEN_140, nomeComponent: 'LaudoBacenResolucao140' },
    {
        id: TipoLaudo.AVALIACAO_FUNDIARIA,
        nomeComponent: 'LaudoAvaliacaoFundiarias'
    },
    {
        id: TipoLaudo.AVALIACAO_DE_AREA_PRODUTIVA,
        nomeComponent: 'LaudoAvaliacaoAreaProdutiva'
    },
    {
        id: TipoLaudo.AVALIACAO_SOCIOAMBIENTAL,
        nomeComponent: 'LaudoAvaliacaoSocioambiental'
    },
    {
        id: TipoLaudo.DINAMICA_EXPLORACAO,
        nomeComponent: 'LaudoDinamicaExploracao'
    },
    {
        id: TipoLaudo.SUPRESSAO_VEGETAL_RED_YELLOW_FLAG,
        nomeComponent: 'LaudoSupressaoVegetalRedYellowFlag'
    },
    {
        id: TipoLaudo.PARCERIA_SUSTENTAVEL_RASTREABILIDADE,
        nomeComponent: 'parceriaSustentavelRastreabilidade'
    },
    { id: TipoLaudo.RENOVABIO, nomeComponent: 'LaudoRenovabio' },
    {
        id: TipoLaudo.RELATORIO_TERRITORIAL,
        nomeComponent: 'LaudoRelatorioTerritorial'
    },
    {
        id: TipoLaudo.ANALISE_DE_COBERTURA_DE_SOLO,
        nomeComponent: 'LaudoAnaliseCoberturaSolo'
    }
];

export default {
    name: 'SelecionarLaudo',

    emits: ['laudoUnico'],

    data() {
        return {
            tipos: [],
            laudoSelecionado: ''
        };
    },

    computed: {
        ...mapGetters(['usuarioLogado'])
    },
    async mounted() {
        await this.getTipoLaudo();
    },
    methods: {
        traduzirNomeLaudo(laudo) {
            return tradutorDeLaudos.traduzirLaudo(laudo);
        },

        async getTipoLaudo() {
            try {
                const idGrupo = this.usuarioLogado.idGrupo;
                const response = await LaudoEmpresaService.buscarTiposLaudo(idGrupo);
                this.tipos = response?.data?.itens;
                this.tipos = orderBy(this.tipos, ['nome']);
                this.$emit(
                    'laudoUnico',
                    this.tipos.length > 1 ? 'false' : 'true'
                );
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'laudos.erro.ocorreuUmerroAoBuscarTiposDeLaudo'
                    )
                });
            }

            if (this.$route?.name === 'Laudos') {
                const route = routesLink.find(r => r?.id === 99);
                this.$router.push({ name: route?.nomeComponent });
                EventBus.$emit('laudo-selecionado', 99);
            }

            const route = routesLink.find(
                r => r?.nomeComponent === this.$route?.name
            );
            if (route?.nomeComponent === 'LaudosDashboard') {
                EventBus.$emit('laudo-selecionado', 99);
            } else {
                this.laudoSelecionado = route?.id;
                EventBus.$emit('laudo-selecionado', this.laudoSelecionado);
            }
        },

        mudarLaudo() {
            const route = routesLink.find(r => r?.id === this.laudoSelecionado);
            this.$router.push({ name: route?.nomeComponent });
            EventBus.$emit('laudo-selecionado', this.laudoSelecionado);
        },

        limparSelecao() {
            const route = routesLink.find(r => r?.id === 99);
            this.$router.push({ name: route?.nomeComponent });
            EventBus.$emit('laudo-selecionado', 99);
            this.laudoSelecionado = '';
        }
    }
};
</script>

<style scoped lang="scss">
#select-laudo {
    display: flex;

    align-items: center;
    justify-content: flex-start;

    gap: 8px;

    .el-select {
        min-width: 350px;
    }
}
</style>

<style>
.tabela-rodape-somatorio-laudos p {
    margin-bottom: 0;
    color: var(--primary);
    font-size: 15px;
    font-weight: 600;
    line-height: 16px;
    padding: 17px 0 15px 21px;
}
.el-pagination {
    padding: 16px 75px 16px 0;
    color: #3b3b3b;
}
.el-pager li.active {
    color: #00413c;
    font-weight: 600;
    font-size: 15px;
    background: #00413c24;
    background-color: var(--secondary) !important;
}
</style>
